export interface IRange {
  min: number;
  max: number;
}

export interface Interval {
  min: number;
  max: number;
  value: number;
}

class _Math {

  public mapRange(input: Interval, output: IRange) {
    return output.min + ((output.max - output.min) / (input.max - input.min))
      * (input.value - input.min);
  }

}

export const Matm = new _Math();



// WEBPACK FOOTER //
// ./src/app/classes/Matm.ts